import { render } from "./NewsUpdateItem.vue?vue&type=template&id=545fcb33&scoped=true"
import script from "./NewsUpdateItem.vue?vue&type=script&lang=js"
export * from "./NewsUpdateItem.vue?vue&type=script&lang=js"

import "./NewsUpdateItem.vue?vue&type=style&index=0&id=545fcb33&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-545fcb33"

export default script